import { render, staticRenderFns } from "./LikeIndexView.vue?vue&type=template&id=2f9cc214&scoped=true"
import script from "./LikeIndexView.vue?vue&type=script&lang=js"
export * from "./LikeIndexView.vue?vue&type=script&lang=js"
import style0 from "./LikeIndexView.vue?vue&type=style&index=0&id=2f9cc214&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9cc214",
  null
  
)

export default component.exports